<template>
  <div v-if="$store.state.users[user] || $store.state.user[user]" class="flex column center container"
    :class="`profile_${user}`" id="profile" style="max-height: 100%">
    <layout class="fill" v-if="($store.state.users && $store.state.users[user]) ||
    ($store.state.user && $store.state.user[user]) ||
    ($store.state.userlist && $store.state.userlist[user]) ||
    ($store.state.show.profile && $store.state.auth.uid)
    ">
      <template #header>
        <div v-if="$store.state.auth.uid === user" class="flex wrap around align-center fill p4 ">
          <a style="border-radius: 100%" type="button" :class="$store.state.show.createtype ? 'update-border ' : 'update '
    " class="p8 r4 flex align-center circle" @click="
    $set(
      $store.state.show,
      'createtype',
      !$store.state.show.createtype
    )
    ">
            <i class="far fa-plus fa-lg"></i>
          </a>
          <span class="p8 flex flexy center md-font wrap" @click="show = section.name" :key="sectionKey"
            v-for="(section, sectionKey) in profileSections" :style="show === section.name
    ? 'font-weight: 900; border: solid rgba(0,0,0,.2); border-left-width: 1px; border-top-width: 1px; border-bottom-width: 0; border-right-width: 1px;'
    : 'border-bottom: 1px solid rgba(0,0,0,.2)'
    ">
            <i class="r4 fa-sm" style="text-shadow: 0 0 4px white" :class="section.icon"></i>
            <code v-if="section.name === show" class="xs-font">{{
    section.name === "close" ? "" : section.name.toUpperCase()
  }}</code>
          </span>
          <code class="l4" v-if="$store.state.auth.uid"><login /></code>
        </div>
      </template>
      <template #content>
        <div style="position: absolute; z-index: 999999999" v-if="$store.state.show.createtype"
          class="container flex success-border l8 r32">
          <createitem></createitem>
        </div>
        <div class="flex column container v-scroll" style="min-width: 240px; height: 100%">
          <div v-if="$store.state.auth.uid === user && show === 'inbox'" class="p8 flex wrap around">
            <message :key="7"></message>
            <notifications />
          </div>

          <div v-else-if="show === 'economics'" class>
            <div class="flex wrap align-center">
              <div class="flex fill between align-center container wrap p16">
                <div class="flex between fill p8">
                  <div @click="tab = moneysection.name" v-for="(moneysection, moneysectioni) in moneysections"
                    :key="'moneysection-' + moneysectioni" :class="tab === moneysection.name ? 'update-text bold' : ''">
                    <i :class="`fa fa-${moneysection.icon}`"></i>
                    {{ moneysection.name.toUpperCase() }}
                  </div>
                </div>
                <component :key="$store.state.counts[tab]" :is="tab" />
              </div>
            </div>
          </div>

          <div v-else-if="show === 'connection'" class="p4 flex wrap between">
            <div class="p8 container b8">
              <div class="flex wrap align-center between">
                <h3>Friends</h3>
                <input class="sm-input sm-font" type="text" v-model="searchFriends" placeholder="Search friends" />
              </div>
              <div class="flex align-start wrap" :key="user" v-for="(type, user) in $store.state.related.connect.user">
                <div v-if="type === 'friend' &&
    (!searchFriends ||
      $store.state.ref.name[user]
        .toLowerCase()
        .indexOf(searchFriends.toLowerCase()) > -1)
    " class="r8 p8 md-font">
                  <user displaySize="48" :userid="user" displaytype="column"></user>
                </div>
              </div>
            </div>
            <div class="p8 container b8">
              <div class="flex wrap align-center between">
                <h3>Values</h3>
                <input class="sm-input sm-font" type="text" v-model="searchValues" placeholder="Search values" />
                <span class="flex container p4">
                  <b class="r4">Browse</b>
                  <state :searchdata="searchValues" :statedata="$store.state.value" parent="value" />
                </span>
                <i @click="showaddvalue = !showaddvalue" class="fa fa-plus update-text"></i>
              </div>
              <div v-if="showaddvalue" class="container update p4 t4">
                <h4 class="border-bottom b4">
                  <i class="fa fa-plus"></i> Add Value
                </h4>
                <input class="b4" type="text" v-model="inputs['addvaluekey']" placeholder="add value key" />
                <textarea v-model="inputs['addvaluedata']" placeholder="add value data" />
                <button class="success-text" @click="
    $store
      .dispatch('create', {
        type: 'value',
        datatype: 'saved',
        key: inputs['addvaluekey'],
        value: inputs['addvaluedata'],
      })
      .then((x) => {
        $set(
          $store.state.value['saved'],
          inputs['addvaluekey'],
          inputs['addvaluedata']
        );
        inputs['addvaluekey'] = '';
        inputs['addvaluedata'] = '';
        showaddvalue = false;
      })
    ">
                  Save Value
                </button>
              </div>
            </div>
            <div class="container p8 b8">
              <h3>Items</h3>
              <imanage></imanage>
            </div>
            <section class="flex p8 container flex wrap align-center">
              <h3><i class="fa fa-folder"></i> Files</h3>
              <div class="flex xs-font l4">
                <media filelist></media>
              </div>
            </section>
          </div>

          <div class="flex around column" v-else-if="show === 'profile'">
            <div class="p4" v-if="$store.state.users[user]">
              <div class="flex column align-center">
                
                <img v-if="$store.state.users[user]" style="margin: 0" class="profile-image p16"
                  :src="$store.state.ref.image[user]" />
                <h1 v-if="$store.state.users[user]" style="margin: 0">
                  {{
    ($store.state.ref.name && $store.state.ref.name[user])
  }}
                </h1>
                <div class="p16 b16" v-if="$store.state.users[user].basics">
                  <icontent class="sm-font" :content="$store.state.users[user].basics.purpose" />
                </div>
                <div v-if="$store.state.auth.uid === user && !isEmailVerified" class="warn-text p8 b8 m8" style="max-width: 400px;">
                  <p class="xs-font">Please verify your email address.</p>
                  <a @click="sendVerificationEmail" class="underline xs-font">Click here to send verification email</a>
                </div>
                <div style="width: 100%" v-if="$store.state.auth.uid !== user" class="flex wrap around align-center">
                  <button class="p8" type="button">
                    <i class="fas fa-money-bill-alt"></i>
                  </button>
                  <span v-if="$store.state.related.connect.user" class="p8 md-font" @click="connect()">
                    <i :class="`r4 fas fa-user-${$store.state.related.connect.user &&
    $store.state.related.connect.user[user] === 'friend'
    ? 'check fa-lg'
    : 'plus'
    }`"></i>
                    {{ status[user] }}
                  </span>
                  <button class="p8" type="button">
                    <i class="fas fa-envelope"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="wrap around flexx m4 t16">
              <div class="flex align-center">
                <b :class="showFeedbackSection === feedbackSection ? 'update-text' : ''
    " :style="showFeedbackSection === feedbackSection
    ? 'font-weight: 900; border: solid rgba(0,0,0,.2); border-left-width: 1px; border-top-width: 1px; border-bottom-width: 0; border-right-width: 1px;'
    : 'border-bottom: 1px solid rgba(0,0,0,.2)'
    " :key="fsKey" v-for="(feedbackSection, fsKey) in ['comments', 'reviews']"
                  @click="showFeedbackSection = feedbackSection" class="md-font p16 flexy" style="text-align: center">
                  <i :class="$store.state.icons[feedbackSection]"></i>
                  {{ feedbackSection.toUpperCase() }}
                </b>
              </div>
              <comments style="
                  border: solid rgba(0, 0, 0, 0.2);
                  border-top-width: 0px;
                  border-left-width: 1px;
                  border-right-width: 1px;
                " v-if="showFeedbackSection === 'comments'" :key="$store.state.componentKeys.comments"
                :commentsid="user"></comments>
              <reviews style="
                  border: solid rgba(0, 0, 0, 0.2);
                  border-top-width: 0px;
                  border-left-width: 1px;
                  border-right-width: 1px;
                " v-if="showFeedbackSection === 'reviews'" :key="$store.state.componentKeys.reviews" :repid="user">
              </reviews>
            </div>
            <div class="m4">
              <div v-if="$store.state.auth.uid === user">
                <component :key="$store.state.componentKeys.profile" id="iform_user" class="iform_user" :is="'iform'"
                  :form-model="userData"></component>
              </div>
              <button @click="$copyText(user)" class="xs-font" type="button">
                <i class="fa fa-copy r4"></i> Copy User ID
              </button>
            </div>
            <!-- <div class="p4 m8 container">
              <h2>Personalities</h2>
              <div class="flex wrap">
                <h3 class="flexy flex column wrap p8" :key="networkKey" v-for="(network, networkKey) in socialNetworks">
                  <div class="fa-stack">
                    <i class="fa fa-ban fa-stack-1x" style="color:rgba(255,50,75,1)"></i>
                    <i :class="`fab fa-${network} fa-stack-1x`" style="color:rgba(255,255,255,.6)"></i>
                  </div>
                  <span>{{network}}</span>
                  <code class="xs-font">Click to connect</code>
                </h3>
              </div>
            </div> -->
          </div>
        </div>
      </template>
    </layout>
    <login v-else />
  </div>
</template>

<script>
export default {
  name: "profile",
  computed: {
    user() {
      if (!this.userid && this.footer) return false;
      if (this.userid && this.userid.indexOf("p__") === 0) {
        let point = this.$store.state;
        this.userid
          .split("state.")[1]
          .split(".")
          .forEach((key) => {
            point = !+key ? point[key] : point[+key];
          });
        return point;
      } else {
        return (
          this.userid || this.$route.params.id || this.$store.state.auth.uid
        );
      }
    },
    isEmailVerified() {
      if (!this.$store.state.auth.uid) return true;
      const user = this.$store.state.auth;
      // Social logins (Google, Facebook, etc.) are considered verified
      if (user.providerData && user.providerData.length > 0) {
        const hasSocialProvider = user.providerData.some(p => p.providerId !== 'password');
        if (hasSocialProvider) return true;
      }
      // If user has provider field (from social login), consider verified
      if (user.provider && user.provider !== 'email') return true;
      // Check if email is verified for password-based logins
      if (user.emailVerified === true) return true;
      // If no email or no provider data, assume not verified for password logins
      return false;
    },
    userData() {
      let defaultdata = this.$store.state.user[this.$store.state.auth.uid];
      return {
        name: "Account Details",
        submit: {
          method: "update",
          type: "user",
          id: this.user,
        },
        forms: [
          {
            name: "basics",
            inputs: [
              {
                inputType: "input",
                label: "email",
                type: "text",
                placeholder: "What is your email address",
                default: (defaultdata.basics && defaultdata.basics.email) || 
                         (this.$store.state.auth && this.$store.state.auth.email) ||
                         window.localStorage.getItem("email"),
              },
              {
                inputType: "input",
                label: "password",
                type: "password",
                placeholder: "Enter password to update email (only needed if changing email)",
                default: "",
                if: ["email", (val) => {
                  const currentEmail = (defaultdata.basics && defaultdata.basics.email) || 
                                      (this.$store.state.auth && this.$store.state.auth.email) ||
                                      window.localStorage.getItem("email");
                  return val && val !== currentEmail;
                }],
              },
              {
                inputType: "input",
                label: "name",
                type: "text",
                placeholder: "Your preferred user name",
                default:
                  (defaultdata.basics && defaultdata.basics.name) ||
                  defaultdata.name ||
                  "XMBL user (nameless)",
              },
              {
                inputType: "file",
                label: "image",
                type: "image",
                placeholder: "Choose a profile picture",
                default: defaultdata.basics && defaultdata.basics.image || this.$store.state.defaults.userimage,
              },
              {
                inputType: "textarea",
                label: "purpose",
                type: "text",
                placeholder: "Why are you here",
                default:
                  (defaultdata.basics && defaultdata.basics.purpose) ||
                  "Be excellent to each other.",
              },
            ],
          },
          {
            name: "payouts and funding",
            inputs: [
              {
                inputType: "select",
                label: "payout to",
                options: [
                  { name: "PayPal", icon: "fab fa-paypal" },
                  { name: "Crypto", icon: "fab fa-btc" },
                  { name: "XYM" },
                  { name: "Bank", icon: "fas fa-money-check-alt" },
                ],
                type: "text",
                placeholder: "Where should we deposit your earnings?",
                default:
                  (defaultdata["payouts and funding"] &&
                    defaultdata["payouts and funding"]["payout to"]) ||
                  "unknown",
              },
              {
                inputType: "input",
                label: "stripe account",
                type: "text",
                placeholder: "Enter your Stripe Connect account ID (acct_...)",
                default:
                  (defaultdata["payouts and funding"] &&
                    defaultdata["payouts and funding"]["stripe account"]) ||
                  "",
              },
              {
                inputType: "input",
                label: "paypal",
                type: "text",
                placeholder: "Paypal email address",
                default:
                  (defaultdata["payouts and funding"] &&
                    defaultdata["payouts and funding"].paypal) ||
                  "",
                if: ["payout to", "PayPal"],
              },
              {
                inputType: "input",
                label: "bitcoin wallet",
                type: "text",
                placeholder: "Bitcoin wallet address",
                default:
                  (defaultdata["payouts and funding"] &&
                    defaultdata["payouts and funding"]["bitcoin wallet"]) ||
                  "",
                if: ["payout to", "Crypto"],
              },
              {
                inputType: "input",
                label: "xmbl token",
                type: "text",
                placeholder: "xmbl token hash",
                default:
                  (defaultdata["payouts and funding"] &&
                    defaultdata["payouts and funding"]["XMBL token"]) ||
                  "",
                if: ["payout to", "xmbl"],
              },
              {
                inputType: "input",
                label: "bank name",
                type: "text",
                placeholder: "Name of bank",
                default:
                  (defaultdata["payouts and funding"] &&
                    defaultdata["payouts and funding"]["bank name"]) ||
                  "",
                if: ["payout to", "Bank"],
              },
              {
                inputType: "input",
                label: "bank account",
                type: "text",
                placeholder: "Bank account number",
                default:
                  (defaultdata["payouts and funding"] &&
                    defaultdata["payouts and funding"]["bank account"]) ||
                  "",
                if: ["payout to", "Bank"],
              },
              {
                inputType: "input",
                label: "bank routing",
                type: "text",
                placeholder: "Bank routing number or transit ID",
                default:
                  (defaultdata["payouts and funding"] &&
                    defaultdata["payouts and funding"]["bank routing"]) ||
                  "",
                if: ["payout to", "Bank"],
              },
            ],
          },
          // {
          //   name: "accounts",
          //   inputs: defaultdata['accounts'].map((x)=>{
          //     return x
          //   })
          // }
        ],
      };
    },
  },
  data() {
    return {
      profileInputs: [
        { name: "image", placeholder: "Drop an image url" },
        { name: "name", placeholder: "What's your name?" },
        { name: "purpose", placeholder: "Describe your purpose" },
      ],
      profileSections: [
        { name: "profile", icon: "fa fa-user" },
        { name: "inbox", icon: "fa fa-inbox" },
        { name: "connection", icon: "fa fa-tree" },
        { name: "economics", icon: "fa fa-money-bill-alt" },
      ],
      inputs: {},
      moneysections: [
        {
          name: "wallet",
          icon: "wallet",
        },
        {
          name: "tokens",
          icon: "coins",
        },
        {
          name: "orders",
          icon: "shopping-basket",
        },
        {
          name: "sales",
          icon: "file-invoice-dollar",
        },
        {
          name: "auctions",
          icon: "gavel",
        },
      ],
      saleTotals: 0,
      scroller: 0,
      searchFriends: "",
      searchValues: "",
      shippingTotals: 0,
      show: (this.$route.query && this.$route.query.section) || "profile",
      showFeedbackSection: "comments",
      showSave: false,
      showaddvalue: false,
      showError: false,
      showRep: false,
      tab: (this.$route.query && this.$route.query.tab) || "wallet",
      socialNetworks: [
        "facebook",
        "instagram",
        "spotify",
        "snapchat",
        "soundcloud",
      ],
      status: {
        [this.user]: this.$store.state.related.connect.user
          ? this.$store.state.related.connect.user[this.user]
          : "",
      },
      total: {
        orders: 0,
        sales: 0,
        shipping: 0,
      },
    };
  },
  methods: {
    connect() {
      this.$store
        .dispatch("relate", {
          id: this.user,
          itemType: "user",
          status:
            !this.$store.state.related.connect.user[this.user] ||
              this.$store.state.related.connect.user[this.user] !== "friend"
              ? "friend"
              : "unfriend",
          type: "connect",
        })
        .then(() => {
          this.$set(
            this.status,
            this.user,
            this.$store.state.related.connect.user[this.user]
          );
        });
    },
    sendVerificationEmail() {
      this.$store.dispatch('auth', { type: 'sendEmailVerification' })
        .then(() => {
          alert('Verification email sent! Please check your inbox.');
        })
        .catch((error) => {
          console.error('Error sending verification email:', error);
          alert('Error sending verification email. Please try again.');
        });
    },
    totals(obj, type) {
      if (type !== "orders" || type !== "sales") {
        return false;
      }
      Object.keys(obj).forEach((objItems) => {
        if (type === "orders") {
          if (!obj[objItems]) {
            return console.log("No orders");
          }
          obj[objItems].paid
            ? (this.total[type] =
              Number(this.total[type]) + Number(obj[objItems].total))
            : void 0;
        } else if (type === "sales") {
          if (!obj[objItems]) {
            return console.log("No sales");
          }
          obj[objItems].paid
            ? obj[objItems].forEach((objItem) => {
              this.total[type] =
                +this.total[type] + +objItem.purchase.cost * +objItem.qty;
              this.total.shipping =
                +this.total.shipping +
                +objItem.purchase["shipping and handling"];
            })
            : void 0;
        }
      });
    },
  },
  mounted() {
    if (
      this.$store.state.app.advanced.hooks.profile &&
      (this.$store.state.app.advanced.hooks.profile.get ||
        this.$store.state.app.advanced.hooks.profile.fun)
    ) {
      let hook = this.$store.state.app.advanced.hooks.profile;
      // let name = hook.get ? hook.get.name : hook.fun.name;
      this.$store.dispatch("run", {
        from: "Profile",
        if: hook.if || [],
        fun: hook.fun,
        payload: hook.getpayload || hook.payload || {},
      });
    }

    (async () => {
      await this.$store
        .dispatch("query", {
          type: "user",
          id: this.user || this.$store.state.auth.uid,
        })
        .then(async () => {
          if (
            this.$store.state.auth.uid &&
            this.$store.state.auth.uid === this.user
          ) {
            await this.$store.dispatch("query", {
              type: "orders",
              user: this.$store.state.auth.uid,
            });
            await this.$store.dispatch("query", {
              type: "sales",
              user: this.$store.state.auth.uid,
            });
            this.totals(this.$store.state.orders, "orders");
            this.totals(this.$store.state.sales, "sales");
            return true;
          }
          if (this.$store.state.reputation[this.user]) {
            this.showRep = true;
          }
          if (this.$route.query) {
            const q = this.$route.query;
            q.section &&
              JSON.stringify(this.profileSections).includes(q.section)
              ? this.$set(this, "show", q.section)
              : null;
            q.section &&
              JSON.stringify(this.profileSections).includes(q.section)
              ? this.$set(this, "tab", q.tab)
              : null;
          }
        });
    })();
    console.log("section", this.section);
    if (this.section) this.$set(this, "show", this.section);
  },
  props: {
    userid: { type: String },
    footer: { type: Boolean },
    section: { type: String },
  },
  created: () => { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.profile-actions button {
  margin-bottom: 4px;
  margin-left: 4px;
  flex: 1 1 20%;
  max-width: 64px;
  max-height: 64px;
}

.profile {
  position: fixed;
  top: 55px;
  bottom: 42px;
  flex-direction: column;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  text-align: left;
  align-items: flex-start;
  -webkit-overflow-scrolling: touch;
  background: rgba(0, 0, 0, 0.6);
  padding: 16px;
}

.profile-image {
  width: 25vh;
  height: 25vh;
  max-width: 600px;
  border-radius: 100%;
  object-fit: cover;
}

.profile-event {
  background: rgba(0, 0, 0, 0.6);
  margin-bottom: 8px;
  padding: 8px;
}
</style>
